import { css } from '@emotion/react';
import { transparentize } from 'polished';

export default $ => css`
  .nav.nav-tabs {
    .nav-item {
      &.side-right {
        margin-left: auto;
        
        & ~ .side-right {
          margin-left: unset;
        }
      }
    }

    .nav-link {
      &:not(.active) {
        border-color: ${$.borderColor};
        color: ${$.primaryMain};
      }

      &:hover {
        background: ${transparentize(0.95, $.primaryMain)};
      }

      &.active {
        border-color: ${$.primaryMain};
        color: ${$.white};
        background-color: ${$.primaryMain};
      }
    }
  }
`;
